import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './GuestSearchBar.scss';

interface GuestSearchBarProps {
  onSearch: (searchText: string) => void;
}

export const GuestSearchBar = ({ onSearch }: GuestSearchBarProps) => {
  return (
    <input
      aria-label="search guests"
      className={cx(typography.t1, styles.guestSearchInput)}
      onChange={(e) => onSearch(e.target.value)}
      placeholder="Search by name, phone, or email"
      type="text"
    />
  );
};
